// Replace all SVG images with inline SVG
export default function svgConverter() {
  if ($('.structure-container').length > 0) {
    $('img.svg').each(function () {
      var $img = $(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      $.get(imgURL, function (data) {
        var $svg = $(data).find('svg');

        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }
        if ($svg.hasClass("nav-bar-panel")) {
          $svg.css('fill', $('.nav-bar').attr('nav-bar-panel'));
        } else if ($svg.hasClass("nav-bar-icon")) {
          $svg.css('fill', $('.nav-bar').attr('nav-bar-icon'));
        }

        $svg = $svg.removeAttr('xmlns:a');
        $img.replaceWith($svg);

        if ($svg.parent().hasClass("center-btn")) {
          $svg.parent().css('background-color', $('.nav-bar').attr('nav-bar-btn'));
        }
      }, 'xml');
    });
  }
}
